import * as React from "react";
import { useEffect, useState } from "react";
import { SearchTextFieldOpts } from "./ContentSearchModal.types";
import {
    IconButtonClear,
    OverlayStyledInputBase,
    Search,
} from "../../SearchHeader/SearchTextField.styles";
import { SearchIcon } from "@icons/SearchIcon";
import { CircleXMarkIcon } from "@icons/CircleXMarkIcon";

export default function OverlaySearchTextField(props: SearchTextFieldOpts) {
    const {
        placeholder = "Search...",
        defaultValue,
        onSearch,
        autoFocus = true,
    } = props;

    useEffect(() => {
        onSearch("");
    }, [onSearch]);

    const [showCross, setShowCross] = useState(false);
    const [searchInputValue, setSearchInputValue] = useState(defaultValue);
    const styledInputBase = {
        placeholder,
        onChange: ({ target }: { target: { value: string } }) => {
            setSearchInputValue(target.value);
        },
        autoFocus,
        value: searchInputValue,
    };

    useEffect(() => {
        onSearch(searchInputValue ?? "");
        setShowCross(!!searchInputValue?.length);
    }, [onSearch, searchInputValue]);

    const clearButton = {
        onClick: () => {
            setSearchInputValue("");
        },
    };

    return (
        <Search>
            <OverlayStyledInputBase
                startAdornment={
                    <SearchIcon
                        color={"var(--community-color-secondary-text)"}
                        width="20px"
                        height="20px"
                    />
                }
                {...styledInputBase}
            />
            {showCross && (
                <IconButtonClear {...clearButton}>
                    <CircleXMarkIcon
                        color={"var(--community-color-transparent-black-20)"}
                    />
                </IconButtonClear>
            )}
        </Search>
    );
}
